module.exports = __WEBPACK_EXTERNAL_MODULE_43__;


//////////////////
// WEBPACK FOOTER
// external "xmldom"
// module id = 43
// module chunks = 0